import React from 'react';
import { makeStyles, Theme } from '@material-ui/core';

import CloverIcon from '../../images/clv_asset_icon.svg';

const useTokenIconStyle = makeStyles<Theme>((theme) => ({
  root: {
    position: 'relative',
    margin: '0px !important',
    display: 'flex',
    alignItems: 'center',
  },
  token: {
    width: 36,
    height: 36,
  },
  chain: {
    width: 12,
    height: 12,
    position: 'absolute',
    bottom: 5,
    left: 26,
  },
}));

// TODO_R: [RP] AssetIcon
// TODO_R: перенести в AssetsTab/components/AssetCard/components
export const TokenIcon = ({ tokenIcon = CloverIcon, chainIcon = '' }) => {
  const classes = useTokenIconStyle();

  return (
    <div className={classes.root}>
      <img className={classes.token} src={tokenIcon} alt="" />
      {chainIcon !== '' && <img className={classes.chain} src={chainIcon} alt="" />}
    </div>
  );
};
